/**
 * Pre-Launch API Client
 *
 * Handles pre-launch phase gate including:
 * - Checking pre-launch status
 * - Verifying user access (KOL or invited)
 */

import config from '@/config';

const BASE_URL = config.API_BASE_URL;

export interface PreLaunchStatusResponse {
  code: number;
  data: {
    isPreLaunch: boolean;
    endTime: string | null;
    hasAccess: boolean;
    requiresInvite: boolean;
    isKol: boolean;
  };
  message?: string;
}

/**
 * Get pre-launch status
 * Check if the app is in pre-launch mode and if the user has access
 *
 * @returns Pre-launch status information
 */
export async function getPreLaunchStatus(): Promise<PreLaunchStatusResponse> {
  const response = await fetch(`${BASE_URL}/auth/pre-launch-status`, {
    method: 'GET',
    credentials: 'include', // Include JWT cookie
  });

  if (!response.ok) {
    throw new Error(`Failed to get pre-launch status: ${response.statusText}`);
  }

  return response.json();
}
